import { useEffect, useState } from "react";
import { STORAGE_KEYS } from "../services/navigation";

const WARN_MS = 10 * 60 * 1000;

export default function SessionExpiryNotice() {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    const tick = () => {
      const at = Number(localStorage.getItem(STORAGE_KEYS.sessionExpiresAt) || 0);
      setLeft(at ? at - Date.now() : null);
    };
    tick();
    const timer = window.setInterval(tick, 30 * 1000);
    return () => window.clearInterval(timer);
  }, []);

  if (left === null || left > WARN_MS) return null;
  const minutes = Math.max(0, Math.ceil(left / 60000));
  return (
    <div className="session-notice" role="status" aria-live="polite">
      {minutes > 0
        ? `Your session ends in about ${minutes} minute${minutes === 1 ? "" : "s"}. Save any draft now; you'll need to sign in again after that.`
        : "Your session has ended. Save a copy of anything you typed, then sign in again."}
    </div>
  );
}
